/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { ACTION_TYPES, getPriceStr, toTitleCase } from "./utils"

import _ from "lodash"

const SeoResults = ({ description, lang, meta, title, searchParams, location }) => {

  const {areas, bedrooms, pType, type, price, commType, mustInclude } = searchParams;

  const actionStr = ACTION_TYPES[pType];
  const priceStr = getPriceStr(price)
  const bedRooms = searchParams.bedrooms

  const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  let propertyType = ""

  if(type == "") {
    propertyType = "property"
  } else if(type == "apartment") {
    propertyType = "apartments"
  } else if(type == "house") {
    propertyType = "houses"
  } else if(type == "new-home") {
    propertyType = "New homes"
  } else if(type == "bungalow") {
    propertyType = "bungalows"
  } else if(type == "bungalow") {
    propertyType = "bungalows"
  } else if(type == "detached-house") {
    propertyType = "Detached houses"
  } else if(type == "semi-detached-house") {
    propertyType = "Semi detached houses"
  } else if(type == "terrace") {
    propertyType = "Terraced houses"
  } else {
    propertyType = capitalize(type.replace(/-/g, ' '))
  }

  let mustIncludeTitle = ""

  if ( mustInclude ) {
    mustIncludeTitle = " with "+mustInclude.join(' and ').replace("parking", "Parking").replace("chain", "Chain").replace("outside", "Outside").replace(/-/g, ' ')
  }

  let desc = "";

  //desc = "Discover a wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle+" with Martyn Gerrard Estate Agents. To filter these results, use our filter below, or for more information about "+ pType+ " property in " + toTitleCase(areas.replace(/-/g, ' ')) + ". please contact us.";

  // if ('sales' === pType) {
  //   desc = "Discover a wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle+" with Martyn Gerrard Estate Agents. To filter these results, use our filter below, or for more information about "+ pType+ " property in " + toTitleCase(areas.replace(/-/g, ' ')) + ". please contact us.";

  //   if ('london' !== areas) {
  //       desc = "Discover a wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle+" with Martyn Gerrard Estate Agents. To filter these results, use our filter below, or for more information about "+ pType+ " property in " + toTitleCase(areas.replace(/-/g, ' ')) + ". please contact us.";
  //   }
  // } else {
  //   // price
  //   if (price.min || price.max){
  //     desc = propertyType + actionStr + areas + "."
  //   }

  // }

    //
    let titlePropertyType = ""

    if(type == "") {
        titlePropertyType = "Property"
    } else if(type == "apartment") {
        titlePropertyType = "Apartments"
    } else if(type == "house") {
        titlePropertyType = "Houses"
    } else if(type == "maisonette") {
        titlePropertyType = "Maisonette"
    } else if(type == "property") {
        titlePropertyType = "Property"
    } else if(type == "bungalow") {
        titlePropertyType = "Bungalows"
    } else if(type == "land") {
        titlePropertyType = "Land"
    } else if(type == "commercial") {
        titlePropertyType = "Commercial"
    } else if(type == "new-home") {
      titlePropertyType = "New homes"
    } else if(type == "detached-house") {
      titlePropertyType = "Detached houses"
    } else if(type == "semi-detached-house") {
      titlePropertyType = "Semi detached houses"
    } else if(type == "terrace") {
      titlePropertyType = "Terraced houses"
    } else {
        titlePropertyType = type
    }

    let bedroomType = ""

    if ( bedrooms ) {
      if(bedrooms > 1)
        bedroomType = " with more than "+bedrooms+" bedrooms";
      else
        bedroomType = " with more than "+bedrooms+" bedroom";
    }

    let descTitle = toTitleCase(titlePropertyType.replace(/-/g, ' ')) + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + priceStr + mustIncludeTitle.toLowerCase()

  desc  = "Looking for "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) +"? Try Martyn Gerrard. We help you with all your property needs."

  if (bedrooms) {
    desc = "Discover "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType+". We specialise in "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) +", contact us today for more information.";
  }
  if (priceStr) {
    desc = "Here are the latest collections of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr+". Our property experts are here to help you find the right property."
  }
  if(propertyType != "property"){
    desc = "Find the wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) +". Contact us for more detail about the properties in "+ toTitleCase(areas.replace(/-/g, ' '))+"."
  }
  if(mustInclude){
    desc = "Discover wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle.toLowerCase()+". Contact Martyn Gerrard leading estate agents."
  }
  if (bedrooms && priceStr) {
    desc = "Look into "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + priceStr +". Contact Martyn Gerrard for more information about the property.";
  }
  if (bedrooms && propertyType != "property") {
    desc = "Find "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType+". Book an appointment with one of our specialists today to find the perfect "+ propertyType +" in "+ toTitleCase(areas.replace(/-/g, ' ')) +".";
  }
  if (bedrooms && mustInclude) {
    desc = "Discover "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + mustIncludeTitle.toLowerCase()+".Our experts help you find the perfect"+ propertyType +" in "+ toTitleCase(areas.replace(/-/g, ' ')) +".";
  }
  if (priceStr && propertyType != "property") {
    desc = "Check here for "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr+". Contact Martyn Gerrard, and get assisted for all your property needs.";
  }
  if (priceStr && mustInclude) {
    desc = "Here are the latest collections of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr + mustIncludeTitle.toLowerCase()+".  Book a viewing for interested property with Martyn Gerrard."
  }
  if(propertyType != "property" && mustInclude){
    desc = "Discover wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle.toLowerCase()+". Contact Martyn Gerrard for more details."
  }
  if(priceStr && bedrooms && mustInclude){
    desc = "Explore "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + priceStr + mustIncludeTitle.toLowerCase()+". Our experts at Martyn Gerrrard help you find the perfect "+ propertyType +" in "+toTitleCase(areas.replace(/-/g, ' '))+".";
  }
  // console.log("Props Desc => ", desc);
  var currentURL = '';
  if (location !== undefined && location.pathname) {
    currentURL = process.env.GATSBY_SITE_URL + location.pathname;
  }

  description = desc

  // set no index for result pagination
  let hasPagination = false;
  if (location !== undefined && location.pathname) {
    let pageStr = location.pathname.split('page-');
    hasPagination = pageStr[1] || false;
    if (pageStr[0] !== undefined) {
     currentURL = process.env.GATSBY_SITE_URL + pageStr[0];
    }
  }

  currentURL = currentURL.replace("/available","")
  currentURL = currentURL.replace("/sortby-price-asc","")
  currentURL = currentURL.replace("/sortby-most-recent","")
  currentURL = currentURL.replace("/sortby-price-desc","")

  if (!currentURL.endsWith('/'))
        currentURL = currentURL + '/';

  let metaItems = [
    {
      name: `description`,
      content: description,
    },
    {
      property: `og:title`,
      content: descTitle,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: `Martyn Gerrard`,
    },
    {
      name: `twitter:title`,
      content: descTitle,
    },
    {
      name: `twitter:description`,
      content: description,
    },
  ].concat(meta);

  if ( hasPagination ) {
    // metaItems.push({
    //   name: `robots`,
    //   content: `noindex`,
    // })
  }

  if ( currentURL ) {
    metaItems.push({
      name: `og:url`,
      content: currentURL,
    })
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link={[
          {
              href: currentURL,
              rel: "canonical"
          }
      ]}
      title={descTitle}
      titleTemplate={`%s | Martyn Gerrard`}
      meta={metaItems}
    />
  )
}

SeoResults.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  title: ``,
  searchParams: [],
}

SeoResults.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  searchParams: PropTypes.any,
}

export default SeoResults
